import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, CardBody, CardHeader, Col, Table } from 'reactstrap';
import * as OrderSummary from '../../../../../../shared/orders/model';
import { Currency } from '../../../../../components/Currency';
import { useTranslation } from '../../../../../translations';
import { checkPermission, useUserSafe } from '../../../../../utils';

interface OrderVouchersProps {
  readonly order: OrderSummary.Order;
  readonly openAddVoucherModal: () => void;
  readonly openDeleteVoucherModal: (voucherId: number) => void;
}

export const OrderVouchers: FC<OrderVouchersProps> = ({
  order,
  openAddVoucherModal,
  openDeleteVoucherModal,
}) => {
  const { ts } = useTranslation();
  const { vouchers } = order;
  const user = useUserSafe();
  const canEdit = order.status === 'unpaid' && checkPermission(user, 'comp:create');

  return (
    <Col lg={11} xs={12}>
      <Card>
        <CardHeader>
          {ts('common.vouchers')}
          {canEdit && (
            <Button
              color="primary"
              id="addVoucher"
              onClick={openAddVoucherModal}
              style={{ float: 'right', padding: '0px 5px' }}
            >
              +
            </Button>
          )}
        </CardHeader>
        <CardBody>
          {vouchers.length === 0 && ts('order_vouchers.no_voucher_order')}
          {vouchers.length > 0 && (
            <Table>
              <thead>
                <tr>
                  <th>{ts('common.code')}</th>
                  <th>{ts('common.display_name')}</th>
                  <th>{ts('common.amount')}</th>
                  {canEdit && <th />}
                </tr>
              </thead>
              <tbody>
                {vouchers.map((voucher) => (
                  <tr id={`voucher-${voucher.id!}`} key={voucher.code}>
                    <td>
                      {voucher.id ? (
                        <Link to={`/housekeeping/vouchers/${voucher.id}`}>{voucher.code}</Link>
                      ) : (
                        voucher.code
                      )}
                    </td>
                    <td>{voucher.displayName}</td>
                    <td>
                      <Currency value={voucher.amount} />
                    </td>
                    {voucher.id && canEdit && (
                      <td>
                        <Button
                          color="danger"
                          id="deleteVoucher"
                          onClick={() => {
                            openDeleteVoucherModal(voucher.id!);
                          }}
                          style={{ float: 'right', padding: '0px 5px' }}
                        >
                          -
                        </Button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};
